/**
 * Auth Hooks - Abstraction Layer for Clerk SDK
 *
 * Components should import auth hooks from this module instead of @clerk/nextjs.
 * This provides a clean abstraction layer that:
 * 1. Isolates SDK dependencies to one location
 * 2. Makes future auth provider changes easier
 * 3. Provides consistent interfaces for auth operations
 *
 * Architecture Rule: AU-01 - Auth Abstraction Layer
 */

// Auth context and user hooks
export {
  useAuthContext,
  useCurrentUser,
  useIsAuthenticated,
  useSignInFlow,
  type AuthContext,
} from "./use-auth-context";

// Organization hooks
export {
  useCurrentOrganization,
  useOrganizationListContext,
  useOrganizationSwitcher,
  useOrganizationUser,
  type CurrentOrganizationContext,
  type OrganizationListContext,
  type OrganizationMembership,
  type OrganizationUserContext,
} from "./use-organization-hooks";
